import { UrlBase, Dashboard, wsBase } from '@/handler/session';

export const configAPI = {
  baseURL: UrlBase.getUrlBase() || process.env.VUE_APP_API_URL || null,
  wsURL: wsBase.getWsBase() || process.env.VUE_APP_WS_URL || null,
};

let _loading; // singleton
let _runtimeConfigLoaded = false;

function publicConfigUrl() {
  const publicPath = process.env.BASE_URL || '/';
  return `${publicPath.replace(/\/$/, '')}/config.json`;
}

async function loadConfig() {
  const res = await fetch(publicConfigUrl(), { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`No se pudo cargar config.json (${res.status})`);
  }

  const cfg = await res.json();

  const baseURL =
    cfg.baseURL ||
    cfg.baseUrl ||
    cfg.apiURL ||
    cfg.apiUrl ||
    cfg.api_url ||
    configAPI.baseURL;

  const wsURL =
    cfg.baseWS ||
    cfg.baseWs ||
    cfg.wsURL ||
    cfg.wsUrl ||
    cfg.ws_url ||
    cfg.websocketURL ||
    cfg.websocketUrl ||
    cfg.websocket_url ||
    configAPI.wsURL;

  console.log('1.configAPI', configAPI)
  console.log('2.configAP----I', configAPI)

  if (baseURL) {
    UrlBase.setUrlBase(baseURL);
    configAPI.baseURL = baseURL;
  }
  
  if (cfg.dashboard) {
    Dashboard.setDashboard(cfg.dashboard);
  }

  // Solo sobrescribir wsURL si encontramos un valor válido
  if (wsURL) {
    wsBase.setWsBase(wsURL);    
    configAPI.wsURL = wsURL;
  } 

  console.log('1.1.configAPI', configAPI)
  console.log('wsURL-->', wsURL)
  _runtimeConfigLoaded = true;
}

export async function waitConfig() {
  if (_runtimeConfigLoaded) return;       // ya está listo
  console.log('2.configAPI', configAPI)
  if (!_loading) {                      // evita fetch duplicados
    const existing = UrlBase.getUrlBase();
    if (existing) {
      configAPI.baseURL = existing;
    }
    //ws
    const wsexisting = wsBase.getWsBase();
    if (wsexisting) {
      configAPI.wsURL = wsexisting;
    }

    _loading = loadConfig().catch(e => {
      console.error('Config load error:', e);
      // Deja los valores de env/localStorage si el config runtime no esta disponible.
    }).finally(() => {
      _runtimeConfigLoaded = true;
    });
  }
  await _loading;
}

// arranca la carga en background, pero los consumidores deben await
waitConfig().catch(()=>{});
export default configAPI;


/*
import { UrlBase, Dashboard } from '@/handler/session';

const configAPI = {
  baseURL: process.env.VUE_APP_API_URL || null,
};

async function loadConfig() {
  try {
    const response = await fetch('/config.json');
    const config = await response.json();

    UrlBase.setUrlBase(config.baseURL);
    Dashboard.setDashboard(config.dashboard);

    configAPI.baseURL = config.baseURL;
  } catch (error) {
    console.error('Error al cargar la configuración:', error);
  }
}

(async () => {
  let url = UrlBase.getUrlBase();

  if (!url) {
    await loadConfig();
  } else {
    configAPI.baseURL = url;
  }
})();

export default configAPI;
*/
